import Link from 'next/link'
import ShopifyImage from '../shopifyImage'

import Layout from '@/components/layout'

export default function displayList({ collection }) {
  return (
    <div className="">
      {collection.products.edges.map(({ node: thisProduct }, index) => {
        return (
          <SingleItem
            key={thisProduct.id}
            name={thisProduct.title}
            imageData={thisProduct.featuredImage}
            href={`/shop/product/${thisProduct.handle}`}
            sideDescription={thisProduct.sideDescription?.value}
            collectionName={collection.title}
            odd={index % 2 === 0}
          />
        )
      })}
    </div>
  )
}

const SingleItem = ({ name, imageData, href, sideDescription, collectionName, odd = false }) => {
  return (
    <div className={`${odd ? 'bg-yellow-50' : ''} py-12`}>
      <Layout>
        <Link href={href}>
          <a>
            <div className="grid md:grid-cols-2">
              <div className={`${odd ? 'md:order-1' : 'md:order-2'} flex items-center justify-center `}>
                <ShopifyImage imageData={imageData} />
              </div>
              <div className={`${odd ? 'md:order-2' : 'md:order-1'} flex items-center justify-center px-8 md:px-16`}>
                <div className="">
                  <h3 className="text-center text-sm uppercase text-gray-700">{collectionName}</h3>
                  <h2 className="mt-4 text-center font-serif text-3xl font-medium">{name}</h2>
                  <div className="mt-4 text-justify text-gray-700">{sideDescription}</div>
                  <div className="mt-6 text-center">
                    <span className="inline-block border-2 border-orange px-4 py-2 font-medium uppercase text-orange">
                      Voir l'article
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </Link>
      </Layout>
    </div>
  )
}
